module.exports = __webpack_public_path__ + "img/share.fcad878c.png";